module.exports = __webpack_public_path__ + "img/pets.d849ed8d.svg";